import { Component } from '@angular/core';

@Component({
    selector: 'app-horizontal-box-list',
    templateUrl: './horizontal-box-list.component.html',
    styleUrl: './horizontal-box-list.component.scss',
    standalone: false
})
export class HorizontalBoxListComponent {

}
